/**
 * Hidden assistant switch (odd/tasks/asistente-voz.md, S5): it only appears after opening any page
 * with `?asistente=<code>`, and the browser remembers it; `?asistente=off` turns it off.
 * It hides the feature, it does not protect anything: the code ships in the bundle.
 */
export const CODIGO_ASISTENTE = 'mc-voz-1811';
export const CLAVE_ASISTENTE = 'mc_asistente';

/** `guardar`: '1' to remember, `null` to forget, `undefined` to leave storage as is. */
export function activacionAsistente(search: string, guardado: string | null): { activo: boolean; guardar: '1' | null | undefined } {
  const valor = new URLSearchParams(search || '').get('asistente');
  if (valor === CODIGO_ASISTENTE) return { activo: true, guardar: '1' };
  if (valor === 'off') return { activo: false, guardar: null };
  return { activo: guardado === '1', guardar: undefined };
}
